import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

/**Import Assets */
import styles from "./styles/ProtectedLayout.module.scss";
// import cssStyles from './styles/notification.module.css';

/**Import Custom Component */
import { WEB_ROUTES } from "../../constants";
import { baseRoute } from "../../Helper";

// Icons
import { FaProductHunt } from "react-icons/fa6";
import { IoIosSettings } from "react-icons/io";
import { MdDashboard, MdOutlineProductionQuantityLimits } from "react-icons/md";
import { useGetAllCategoriesQuery, useGetDashboardDataQuery } from "../../Data/services/dashboardApi";
import { removeToken } from "../../Data/services/localStorageService";
import Toast from "../../Hooks/useToast";
import LogoutModal from "../Modals/LogoutModal";
import CustomNavbar from "./Navbar";
import { useLogoutUserMutation } from "../../Data/services/userAuthApi";

export default function ProtectedLayout({
  isSearchBar,
  isSettingButton,
  selectedRoute,
  children,
}) {
  const [collapsed, setCollapsed] = useState(window.innerWidth > 991);

  // inject data
  // const { data } = useGetAllCategoriesQuery({
  //   refetchOnMountOrArgChange: true,
  // });

  // console.log(data);

  const [logoutModal, setLogoutModal] = useState(false);

  const navigate = useNavigate();
  // todo: menu
  const items = [
    {
      label: "Dashboard",
      icon: <MdDashboard />,
    },
    // {
    //   label: "User Management",
    //   icon: <FaUser />,
    // },
    // {
    //   label: "Category Management",
    //   icon: <MdCategory />,
    // },
    // {
    //   label: "Sub Category Management",
    //   icon: <MdCategory />,
    // },
    {
      label: "Product Management",
      icon: <FaProductHunt />,
    },
    {
      label: "Order Management",
      icon: <MdOutlineProductionQuantityLimits />,
    },
    // {
    //   label: "Promos Management",
    //   icon: <FaChartArea />,
    // },
    // {
    //   label: "Blogs Management",
    //   icon: <FaBlogger />,
    // },
    // {
    //   label: "Alert Management",
    //   icon: <IoIosAlert />,
    // },
    // {
    //   label: "Send Notification",
    //   icon: <IoNotifications />,
    // },
    {
      label: "Settings",
      icon: <IoIosSettings />,
    },
  ];

  const handleToggle = () => {
    setCollapsed(!collapsed);
  };

  const handleMenuClose = () => {
    setCollapsed(false);
  };

  const handleViewProfile = () => {
    navigate(baseRoute(WEB_ROUTES.PROFILE));
  };

  const [logOutUser, { isError, isLoading, isSuccess }] =
    useLogoutUserMutation();

  const handleLogout = async () => {
    try {
      const response = await logOutUser();

      // console.log(response.error.status);
      console.log(response);

      if (response.error && response.error.status >= 400) {
        const message = await response.error.data.message;
        Toast(`${message}`, "error");
        // console.log(message)
      }

      if (!response.error && response.data.code === 200) {
        // navigate("/account");
        Toast("Logged Out Successfully", "success");
        setInterval(() => {
          window.location.reload();
          removeToken();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  const handleLogoutModalOpen = () => {
    setLogoutModal(true);
  };

  const handleLogoutModalClose = () => {
    setLogoutModal(false);
  };

  return (
    <div className={styles.ProtectedLayout}>
      <div className={styles.background} onClick={handleMenuClose}></div>
      {
        // <div
        //   className={`${styles.menu} ${
        //     collapsed ? `${styles.collapsed} visible` : styles.notCollapsed
        //   }`}
        //   id="sider"
        // >
        //   <div
        //     className={`${styles.logo} ${!collapsed ? styles.notCollapsed : ""}`}
        //     to={`${process.env.REACT_APP_DOMAIN_DIR}/dashboard`}
        //   >
        //     <img
        //       src={collapsed ? "/images/logo_name.png" : "/images/small_logo.png"} //todo:
        //       alt="Logo"
        //       className={
        //         collapsed ? styles.imageCollapsed : styles.imageNotCollapsed
        //       }
        //       width={"100%"}
        //       height={"100%"}
        //     />
        //   </div>
        //   {/* <div className={`${styles.drawer} ${collapsed ? styles.collapsed : ''}`}>
        //               <span onClick={handleToggle}>
        //                   <BiLogOut />
        //               </span>
        //           </div> */}
        //   {items.map(({ icon, label }, index) => {
        //     return (
        //       <Link
        //         to={`${process.env.REACT_APP_DOMAIN_DIR}/${label
        //           .toLowerCase()
        //           .replace(/[^A-Z0-9]/gi, "-")}`}
        //         className={`${styles.item} ${
        //           index === selectedRoute ? styles.active : ""
        //         }`}
        //         key={index}
        //       >
        //         <span style={{ fontSize: "20px", display: "flex" }}>
        //           {" "}
        //           {icon}{" "}
        //         </span>
        //         {collapsed ? <p>{label}</p> : ""}
        //       </Link>
        //     );
        //   })}
        //   <Link
        //     className={styles.item}
        //     // onClick={handleLogout}
        //     onClick={handleLogoutModalOpen}
        //     // onClick={() =>
        //     //   submit("Confirm Logout", "Are you sure you want to logout?", () =>
        //     //     handleLogout()
        //     //   )
        //     // }
        //   >
        //     {/* <img src={logout} alt="Icon1" width={20} height={20} /> */}
        //     <span style={{ fontSize: "20px", display: "flex" }}>
        //       <TbLogout2 />
        //     </span>
        //     {collapsed ? <p>Logout</p> : ""}
        //   </Link>
        // </div>
      }
      <div className={styles.routeContent}>
        {logoutModal ? (
          <LogoutModal
            handleLogoutModalClose={handleLogoutModalClose}
            isLoading={isLoading}
            data={""}
            onLogout={handleLogout}
          />
        ) : null}

        <CustomNavbar
          isSearchBar={isSearchBar}
          isSettingButton={isSettingButton}
          handleToggle={handleToggle}
          onClickLogout={handleLogoutModalOpen}
        />
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
}
